import { createPortal } from 'react-dom';
import { Bell } from '@phosphor-icons/react';

function PushPermissionModal({ onRequest, onDismiss }) {
  const handleDismiss = () => {
    localStorage.setItem('pushModalDismissed', 'true');
    onDismiss();
  };

  if (typeof document === 'undefined') return null;

  // Portal a body para escapar transform ancestors (slider de MarketLayout).
  return createPortal(
    <div className="fixed inset-0 bg-black/40 z-50 flex items-end justify-center">
      <div className="bg-white rounded-t-2xl p-6 w-full max-w-md animate-slide-up">
        <div className="bg-primary-100 rounded-full p-3 w-fit mx-auto">
          <Bell className="w-12 h-12 text-brand-primary" />
        </div>

        <h2 className="text-lg font-bold text-center mt-4">
          ¡No te pierdas nada!
        </h2>

        <p className="text-sm text-gray-500 text-center mt-2">
          Activa las notificaciones para recibir actualizaciones de tus pedidos y ofertas especiales
        </p>

        <button
          onClick={onRequest}
          className="w-full py-3 bg-brand-primary text-white rounded-xl font-semibold mt-4 active:scale-[0.98] transition-transform"
        >
          Activar notificaciones
        </button>

        <button
          onClick={handleDismiss}
          className="w-full text-sm text-gray-400 text-center mt-3 cursor-pointer py-1"
        >
          Ahora no
        </button>
      </div>
    </div>,
    document.body
  );
}

export default PushPermissionModal;
